import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Table,
		TableBody,
		TableCell,
		TableHead,
		TablePagination,
		TableRow,
		Typography,
		IconButton,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import ReactSelect from 'react-select';

import {
	Search as SearchIcon,
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    LOAI_GOI_CUOC,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    OPERATOR_THEME,
    CU_PHAP_DANG_KY_GOI_CUOC,
    MAXIMUM_IMAGES,
		CONFIRM_TYPES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import { Helmet } from "react-helmet";

import numeral from 'numeral';

import ConfirmDialog from '../ConfirmDialog';

import { Settings, Download, Upload, Cached } from '@material-ui/icons';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { KhoAction } from 'src/actions/kho.action';
import CreateEditDialog from '../kho-detail/CreateEditDialog';
import { KhophieuAction } from 'src/actions/khophieu.action';

const KhophieuView = (props) => {
    const dispatch = useDispatch()
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
		const { selected: selectedKhophieu } = useSelector(state => state.khophieu)
		const [open, setOpen] = useState(false);
		const [confirm, setConfirm] = useState(false);
  		const [confirmType, setConfirmType] = useState("");
		const [title, setTitle] = useState("");
		const [selected, setSelected] = useState({});
		const [content, setContent] = useState("");
		const [openCreateKho, setOpenCreateKho] = useState(false);
		const [openCreateKhoType, setOpenCreateKhoType] = useState("");
		const { isLoading } = useSelector(state => state.app);

		const trangThaiOptions = [
			{ value: 'cho_duyet', label: 'Chờ duyệt' },
			{ value: 'da_duyet', label: 'Đã duyệt' },
			{ value: 'tu_choi', label: 'Từ chối' }
		];

    useEffect(() => {
        
    }, [])

		const handleConfirmOpen = (type, kho) => {
			setSelected(kho);
			setConfirmType(type);
			if (confirmType === CONFIRM_TYPES.DELETE) {
				setTitle("Xoá bản ghi")
				setContent(`Xác nhận xoá bản ghi `)
			}
			setConfirm(true);
		};
	
		const onConfirm = () => {
			setConfirm(false);
			if (confirmType === CONFIRM_TYPES.DELETE) {
				dispatch(KhoAction.del(selected.id))
				return;
			}
		}

		const handleConfirmClose = () => {
			setConfirm(false);
		};
	
		const onSelected = (id) => {
			dispatch(KhoAction.findOne(id));
			setOpen(true);
		};
	
		const handleClose = () => {
			setOpen(false);
		};

		const handleOpenCreateKho = (id) => {
			dispatch(KhoAction.findOne(id));
			setOpenCreateKhoType("EDIT");
			setOpenCreateKho(true);
		};

		const handleCloseCreateKho = () => {
			setOpenCreateKho(false);
		};

		const refreshKho = () => {
			if (props.khophieu) {
				dispatch(KhophieuAction.findOne(props.khophieu.id));
			}
		};

		const createKho = () => {
			setOpenCreateKhoType("CREATE");
			setOpenCreateKho(true);
		};

		const setTrangThai = async (id, trang_thai, trang_thai_text) => {
			const question = "Xác nhận đặt trạng thái '" + trang_thai_text + "'?";
			if (window.confirm(question)) {
				try {
					// const response = await dispatch(KhoAction.setTrangThai(id, { trang_thai }));
					// if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
					// else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
					
					dispatch(KhoAction.update(id, { 
						trang_thai,
					}))
				} catch (error) {
					if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
				}
			} else {
				
			}
		};

		const copyToClipboard = (content) => {
			navigator.clipboard
				.writeText(content)
				.then(() => {
					console.log('String copied to clipboard:', content);
					// showToast('success', `Đã copy: ${content}`);
				})
				.catch((error) => {
					console.error('Unable to copy string:', error);
					// showToast('error', `Lỗi không thể copy: ${content}`);
				});
		};
	
		const setColor = (value) => {
				if (value == 'cho_duyet') return 'orange';
				else if (value == 'da_duyet') return 'green';
				else if (value == 'tu_choi') return 'red';
				else if (value == 'positive') return 'green';
				else if (value == 'negative') return 'red';
				else return '#000000';
		};

    return (<>
        <Helmet>
            <style>{`
							
            `}</style>
        </Helmet>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
                <DialogTitle style={{color: 'teal'}}>
					{props.khophieu && props.khophieu.so_phieu ? props.khophieu.so_phieu : '' }
					<Button
						color="primary"
						variant="contained"
						onClick={createKho}
						style={{ height: '20px', padding: 0, marginTop: 0, width: "20px", minWidth: '20px', marginLeft: '5px', backgroundColor: 'orange', fontWeight: 'normal' }}
					>
						+
					</Button>
					<Button
						color="primary"
						variant="contained"
						onClick={refreshKho}
						style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
					>
						{!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
					</Button>
				</DialogTitle>
                <DialogContent className='order_container'>
                    <div className="otp-container">
                        {/* Nút đóng */}
                        {/* <button className="otp-close-btn" onClick={props.handleClose}>
                            &times;
                        </button> */}
                        
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>
										#
									</TableCell>
									<TableCell>
										Sản phẩm
									</TableCell>
									<TableCell>
										Nhập (+) / Xuất (-)
									</TableCell>
									<TableCell>
										Đơn giá
									</TableCell>
									<TableCell>
										Giá trị
									</TableCell>
									<TableCell>
										Ghi chú
									</TableCell>
									<TableCell>
										Ngày tạo
									</TableCell>
									<TableCell>
										Người nhập
									</TableCell>
									<TableCell>
										Người cập nhật cuối
									</TableCell>
									<TableCell>
										Người duyệt
									</TableCell>
									<TableCell>
										Trạng thái
									</TableCell>
									<TableCell>
										Thao tác
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{selectedKhophieu && selectedKhophieu.khos && selectedKhophieu.khos.map((kho, index) => (
									<TableRow
										hover
										key={kho.id}
									>
										<TableCell>
											{index + 1}
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												<span style={{color: 'blue'}}>
													[{kho.loai_san_pham_text == "xe_may_dien" && <span style={{ }}>Xe máy điện</span>}
													{kho.loai_san_pham_text == "xe_dap_dien" && <span style={{ }}>Xe đạp điện</span>}
													{kho.loai_san_pham_text == "ac_quy" && <span style={{ }}>Ắc quy</span>}
													{kho.loai_san_pham_text == "pin" && <span style={{ }}>Pin</span>}
													{kho.loai_san_pham_text == "phu_tung" && <span style={{ }}>Phụ tùng</span>}
													{kho.loai_san_pham_text == "khac" && <span style={{ }}>Khác</span>}]
												</span>
												<br></br>
												<span style={{color: 'green', fontWeight: 'bold'}}>{kho.ten_san_pham_text}</span>
												<br></br>
												<span style={{color: 'red', fontStyle: 'italic'}}>({kho.phien_ban_san_pham_text})</span>
												{kho.ma_san_pham && <>
													<br></br>
													<br></br>
													<span style={{fontWeight: 'bold'}}>- Mã sản phẩm: </span><span>{kho.ma_san_pham}</span>
												</>}
												{kho.thong_tin_them && <>
													<br></br>
													<br></br>
													<span style={{fontWeight: 'bold'}}>- Thông tin thêm: </span><span>{kho.thong_tin_them}</span>
												</>}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												<span style={{fontWeight: 'bold', color: setColor(kho.nhap_xuat < 0 ? 'negative' : 'positive')}}>{numeral(kho.nhap_xuat).format('0,0')}</span>
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												<span style={{fontWeight: 'bold', color: 'blue'}}>{numeral(kho.don_gia).format('0,0')}</span>
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												<span style={{fontWeight: 'bold', color: setColor(kho.nhap_xuat < 0 ? 'negative' : 'positive')}}>{numeral(kho.don_gia * kho.nhap_xuat).format('0,0')}</span>
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												{kho.ghi_chu}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												{moment(kho.thoi_diem_tao_dong_bo).format('DD-MM-YYYY HH:mm:ss')}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												{kho.username_nguoi_nhap}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												{kho.username_chinh_sua_cuoi_cung}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color="textPrimary"
												variant="body1"
											>
												{kho.username_nguoi_duyet}
												<br></br>
												{kho.thoi_diem_duyet ? '(' + moment(kho.thoi_diem_duyet).format('DD-MM-YYYY HH:mm:ss') + ')' : ''}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												color=""
												variant="body1"
											>
												{1 < 0 && role.priority < 3 && kho.trang_thai == 'cho_duyet' ? <>
													<Select1
														style={{
															fontSize: '14px',
															width: '120px',
															marginBottom: '15px',
															color: setColor(kho.trang_thai)
														}}
														variant="outlined"
														value={kho.trang_thai}
														onChange={(e) => {
															const value = e.target.value;
															const text = trangThaiOptions.find(opt => opt.value === value)?.label || '';
															setTrangThai(kho.id, value, text);
														}}
													>
														{trangThaiOptions.map((opt) => (
															<MenuItem
																key={opt.value}
																value={opt.value}
																style={{ color: setColor(opt.value) }}
															>
																{opt.label}
															</MenuItem>
														))}
													</Select1>
												</> : <>
													{kho.trang_thai == "cho_duyet" && <span style={{ color: setColor('cho_duyet'), paddingLeft: 5 }}>Chờ duyệt</span>}
													{kho.trang_thai == "da_duyet" && <span style={{ color: setColor('da_duyet'), paddingLeft: 5 }}>Đã duyệt</span>}
													{kho.trang_thai == "tu_choi" && <span style={{ color: setColor('tu_choi'), paddingLeft: 5 }}>Từ chối</span>}
												</>}
											</Typography>
										</TableCell>
										<TableCell>
											{kho.trang_thai == "cho_duyet" && <IconButton aria-label="edit" onClick={() => handleOpenCreateKho(kho.id)}>
												<Edit3Icon color='green' />
											</IconButton>}
											{role.priority < 3 && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, kho)}>
												<Trash2Icon color='red' />
											</IconButton>}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    {/* <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button> */}
                </DialogActions>
            </Dialog >
			<CreateEditDialog open={openCreateKho} handleClose={handleCloseCreateKho} type={openCreateKhoType} khophieu={selectedKhophieu && selectedKhophieu.so_phieu ? selectedKhophieu : null} />
			<ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.id} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
		</LocalizationProvider>
    </>);
}

export default KhophieuView;